import template from './resetPassword.html';
import './resetPassword.scss';

class ResetPasswordController {
  constructor($scope) {
    'ngInject';

    this.$scope = $scope;

    this.passwords = {
      newPassword: '',
      confirmNewPassword: '',
    };
    this.errorMessage = '';
  }
  reset() {
    if (!this.loading && this.form.$valid) {
      this.errorMessage = '';
      const { newPassword, confirmNewPassword } = this.passwords;
      const error = this.validatePassword({ password: newPassword });
      if (error) {
        this.errorMessage = error;
      } else if (newPassword !== confirmNewPassword) {
        this.errorMessage = 'The passwords don\'t match';
      } else {
        this.onReset({ newPassword, confirmNewPassword });
      }
    }
  }
  $onChanges({ error }) {
    if (error && error.currentValue) {
      this.errorMessage = error.currentValue;
    }
  }
  get form() {
    return this.$scope.nzLoginBox_form;
  }
}

export default {
  controller: ResetPasswordController,
  template,
  bindings: {
    create: '<',
    error: '<',
    loading: '<',
    success: '<',
    onReset: '&',
    goBackUrl: '<',
    privacyPolicyUrl: '<',
    validatePassword: '&',
  },
};
